export default "__VITE_ASSET__BdWban2Q__"